module.exports = __webpack_public_path__ + "b62709efb9016c3ea9bd684f8d64517d.jpg";